import { render } from "./S3Image.vue?vue&type=template&id=f6ab2de6&lang=pug"
import script from "./S3Image.vue?vue&type=script&lang=js"
export * from "./S3Image.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
